import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

const getAllInsuranceModules = createAsyncThunk('basicinfo/getAllInsuranceModules', async () => {
  return await BasicInfoHttpGetService({
    url: `${_apiPathManagerConfig?.BasicInfo.InsuranceModule.GetAllInsuranceModules}`,
  });
});

export default getAllInsuranceModules;
